<template>
  <v-container fluid class="print_area">
    <div v-if="loading">
      <div class="mb-3">
        <v-skeleton-loader type="list-item-two-line"></v-skeleton-loader>
      </div>
      <v-skeleton-loader type="table"></v-skeleton-loader>
    </div>
    <div v-else>
      <v-row justify="center">
        <v-col cols="12" class="hide_print">
          <v-row no-gutters justify="space-between" class="hide_print">
            <div class="text-h2 text-primary mb-5">
              Acompanhamento {{relatorio == 1 ? 'de Produtividade' : relatorio == 2 ? 'Financeiro' : 'de Produtividade e Financeiro'}}
            </div>
            {{logo}}
            <div v-if="resultadoFiltro">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn class="ui-btn-inherit mt-1" v-bind="attrs" v-on="on" @click="callPrint()">
                    <v-icon large color="primary">
                      print
                    </v-icon>
                  </v-btn>
                </template>
                <span>Imprimir relatório</span>
              </v-tooltip>
            </div>
          </v-row>
          <v-row no-gutters class="hide_print mb-10">
            <div>
              <VueCtkDateTimePicker
                v-on:callback="changeDates"
                v-model="data_entrada"
                class="date-picker"
                locale="pt-BR"
                :no-header="true"
                :no-value-to-custom-elem="true"
                :overlay="true"
                :range="true"
                :formatted="'L'"
                :format="'YYYY-MM-DD'"
                color="#EC6521"
                :dark="$vuetify.theme.dark"
                button-color="#EC6521"
                :custom-shortcuts="labels"
                :no-button="true"
                :noClearButton="true"
                :auto-close="true"
                :loading="loadingSearch"
                :disabled="loadingSearch"
                :submit="retornoData()"
              >
                <v-btn class="px-2 py-1 ui-search_data" elevation="0" v-ripple="{ class: `success--text` }">
                  <b class="text text-primary">
                    Período: {{ formatDateFront(de, 'LL')}} - {{formatDateFront(ate, 'LL') }}
                  </b>
                </v-btn>
              </VueCtkDateTimePicker>
            </div>
            <div class="ml-3 mw_maior">
              <v-autocomplete
                  v-if="nivelUsuarioApelido === 'M' || nivelUsuarioApelido === 'D'"
                  :menu-props="{ offsetY: true}"
                  class="ml-3"
                  :items="integradores"
                  label="Integrador"
                  append-icon="expand_more"
                  v-model="integrador"
                  hide-details=""
                  :loading="loading || loadingIntegradores"
                  :disabled="loading || loadingIntegradores"
                  outlined
                  @click:clear="getClientes()"
                  clearable
                  clear-icon="close"
                  @change="() => {
                    this.cliente = null
                    this.clientes = []
                    this.fatura = null
                    this.faturas = []
                    getClientes()
                  }"
                ></v-autocomplete>
            </div>
            <div class="ml-3 mw_maior">
              <v-autocomplete
                :menu-props="{ offsetY: true}"
                v-model="cliente"
                :items="clientes"
                clearable
                clear-icon="close"
                label="Cliente"
                hide-details=""
                append-icon="expand_more"
                :loading="loadingSearch || loadingClientes"
                :disabled="loadingSearch || loadingClientes"
                outlined
                @click:clear="() => {
                  this.fatura = null
                  this.faturas = []
                  selecionaFatura()
                }"
                @change="() => {
                  this.fatura = null
                  this.faturas = []
                  selecionaFatura()
                }"
              >
              </v-autocomplete>
            </div>
            <div class="ml-3 mw_maior">
              <v-autocomplete
                :menu-props="{ offsetY: true}"
                v-model="fatura"
                :items="faturas"
                clearable
                clear-icon="close"
                label="Fatura"
                hide-details=""
                append-icon="expand_more"
                :loading="loadingSearch || loadingFaturas"
                :disabled="loadingSearch || loadingFaturas"
                outlined
              >
              </v-autocomplete>
            </div>
            <div class="ml-3 mw_maior">
              <v-autocomplete
                :menu-props="{ offsetY: true}"
                v-model="relatorio"
                :items="relatorios"
                clearable
                clear-icon="close"
                label="Modelo de relatório"
                hide-details=""
                append-icon="expand_more"
                :loading="loadingSearch"
                :disabled="loadingSearch"
                outlined
              >
              </v-autocomplete>
            </div>
            <div class="ml-3 search_btn">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn color="ui-btn-inherit ui-search_btn" v-bind="attrs" v-on="on" :loading="loadingSearch" :disabled="loadingSearch || fatura === '' ? true : false" @click="applyFilter()">
                    <v-icon>search</v-icon>
                  </v-btn>
                </template>
                <span>Filtrar</span>
              </v-tooltip>
            </div>
          </v-row>
        </v-col>
        <v-col cols="12" sm="12" md="12" lg="12" xl="12">
          <div class="print_container" v-if="resultadoFiltro">
            <div>
              <div class="primeiro_relatorio" v-if="relatorio === 1 || relatorio === 3">
                <v-row justify="center">
                  <v-col cols="6" sm="8" md="6" lg="6" xl="5" class="col_print">
                    <div class="text-h3 text-primary capitalize_text">
                      {{formatDateFront(resultadoFatura.fatura.ucf_fim_ciclo, 'MMMM [de] YYYY')}}
                    </div>
                    <div class="text text-primary">
                      De {{ formatDateFront(resultadoFatura.fatura.ucf_inicio_ciclo)}} a {{formatDateFront(resultadoFatura.fatura.ucf_fim_ciclo)}}
                    </div>
                    <div class="text-h1 mb-2 mt-2 text-print" v-if="resultadoFatura && resultadoFatura.fatura && resultadoFatura.fatura.unidade.cliente">
                      Olá <b>{{resultadoFatura.fatura.unidade.cliente.cli_nome}}</b>
                    </div>
                    <div class="text-primary potencia_detalhe" v-if="resultadoFatura.producao">
                      Potência instalada {{resultadoFatura.producao.potencia_total}}
                    </div>
                    <div class="mb-2">
                      <div class="area_img_fundo">
                        <img src="@/assets/img/pdf_bg.png" alt="Carteira">
                        <div class="economizou font_valor" v-if="resultadoFatura.economia">
                          R$ {{resultadoFatura.economia.periodo ? resultadoFatura.economia.periodo : '0,00'}}
                        </div>
                        <div class="inicio font_valor">
                          R$ {{resultadoFatura.economia.total ? resultadoFatura.economia.total : '0,00'}}
                        </div>
                      </div>
                    </div>
                    <div class="text-small text-print valores_aproximados">
                      *Os valores em R$ são aproximados.
                    </div>
                    <div class="text-h2 mb-2 mt-2 margin_contribuicao producao_print text-print">
                      Sua contribuição para o mundo
                    </div>
                    <v-card elevation="2" class="mb-4 mw_vcard vcard_border mt-3">
                      <v-row no-gutters align="center">
                        <div class="left_card">
                          <img src="@assets/img/arvores.png" alt="Árvores">
                        </div>
                        <div class="right_card">
                          <div class="text-h1 text-primary">
                            {{arvores}}
                          </div>
                          <div class="text text-print mt-3">
                            Árvore{{arvores === 1 ? '' : 's'}} {{arvores === 1 ? 'foi' : 'foram'}} cultivada{{arvores === 1 ? '' : 's'}}
                          </div>
                        </div>
                      </v-row>
                    </v-card>
                    <v-card elevation="2" class="mw_vcard vcard_border">
                      <v-row no-gutters align="center">
                        <div class="left_card">
                          <img src="@assets/img/co2.png" alt="CO2">
                        </div>
                        <div class="right_card">
                          <div class="text-h1 text-primary">
                            {{tco2}}
                          </div>
                          <div class="text text-print mt-3">
                            Toneladas de CO2 evitados
                          </div>
                        </div>
                      </v-row>
                    </v-card>
                  </v-col>
                  <v-col cols="6" sm="4" md="6" lg="6" xl="5" class="col_area col_print">
                    <v-card class="mb-3 text-center vcard_border pt-2 mw_vcard" elevation="2">
                      <img v-if="!user.logo_sistema" src="@assets/img/logo.png" alt="Logo">
                      <img v-else :src="user.logo_sistema" alt="Logo">
                    </v-card>
                    <v-card class="mb-3 vcard_border mw_vcard pr-8" elevation="2" v-if="resultadoFatura.producao">
                      <v-row no-gutters align="center">
                        <div class="left_card">
                          <img src="@assets/img/img_solar.png" alt="Solar">
                        </div>
                        <div class="right_card">
                          <div class="text text-print">
                            Sua produção em relação ao esperado foi de:
                          </div>
                          <div class="text-primary text-h1 mt-3">
                            {{resultadoFatura.producao.media}}%
                          </div>
                        </div>
                      </v-row>
                    </v-card>
                  <div class="text-h2 mb-3 margin_contribuicao text-print producao_print">
                      Sua produção dos últimos meses:
                    </div>
                    <div class="grafico_print">
                      <bar-chart :options="barChartOptions" :height="180" :data="barChartData"></bar-chart>
                      <div class="mt-2">
                        <v-row no-gutters justify="center">
                          <div class="mr-3">
                            <div class="cor bg-gray text-gray"></div><span class="legenda text-print">Produção (kWh)</span>
                          </div>
                          <div class="mr-3">
                            <div class="cor bg-primary text-primary"></div> <span class="legenda text-print">Produção esperada (kWh)</span>
                          </div>
                          <div class="mr-3">
                            <div class="cor bg-yellow text-yellow"></div> <span class="legenda text-print">Consumo instantâneo (kWh)</span>
                          </div>
                          <div>
                            <div class="cor bg-blue text-blue"></div> <span class="legenda text-print">Energia consumida (kWh)</span>
                          </div>
                        </v-row>
                      </div>
                    </div>
                    <div class="grafico">
                      <bar-chart :options="barChartOptions" :height="180" :data="barChartData"></bar-chart>
                      <div class="mt-2">
                        <v-row no-gutters justify="center">
                          <div class="mr-3">
                            <div class="cor bg-gray text-gray"></div><span class="legenda text-print">Produção (kWh)</span>
                          </div>
                          <div class="mr-3">
                            <div class="cor bg-primary text-primary"></div> <span class="legenda text-print">Produção esperada (kWh)</span>
                          </div>
                          <div class="mr-3">
                            <div class="cor bg-yellow text-yellow"></div> <span class="legenda text-print">Consumo instantâneo (kWh)</span>
                          </div>
                          <div>
                            <div class="cor bg-blue text-blue"></div> <span class="legenda text-print">Energia consumida (kWh)</span>
                          </div>
                        </v-row>
                      </div>
                    </div>
                    <div class="resultados mt-5" v-if="resultadoFatura.producao">
                      <img src="@assets/img/resultados.png" alt="Resultados">
                      <div class="consumo_registrado text_number text-print">
                        {{resultadoFatura.fatura.ucf_consumida}} kWh
                      </div>
                      <div class="unidade_geradora text_number text-print">
                      {{resultadoFatura.producao.total_unidade}}
                      </div>
                      <div class="consumo_instantaneo text_number text-print">
                        <!-- {{resultadoFatura.fatura.ucf_energia_compensada}} kWh -->
                        {{ calculaConsumoInstantaneo(resultadoFatura) }} kWh
                      </div>
                      <div class="energia_injetada text_number text-print">
                        {{resultadoFatura.fatura.ucf_energia_injetada}} kWh
                      </div>
                      <div class="geracao text_number text-print">
                        {{resultadoFatura.producao.total_gerado}}
                      </div>
                    </div>
                  </v-col>
                </v-row>
                <div class="parabens">
                  <v-card elevation="2" class="text-center vcard_border_parabens pt-3 pb-1">
                    <v-row no-gutters justify="center" align="center">
                      <div>
                        <img src="@assets/img/parabens.png" alt="Parabéns">
                      </div>
                      <div class="pl-2">
                        <div class="text-h1 text-primary">
                          Parabéns pelos seus resultados!
                        </div>
                        <div class="text text-print">
                          Além de economizar, você torna nossa sociedade mais sustentável.
                        </div>
                      </div>
                    </v-row>
                  </v-card>
                </div>
              </div>
              <!-- fim primeiro relatório -->
              <div class="segundo_relatorio" v-if="relatorio === 2 || relatorio === 3">
                <div :class="relatorio === 3 ? 'segunda_pagina' : ''">
                  <div class="topo_segunda_pagina">
                    <v-row no-gutters justify="space-between" align="center">
                      <div>
                        <img v-if="!user.logo_sistema" src="@assets/img/logo.png" alt="Logo">
                        <img v-else :src="user.logo_sistema" alt="Logo">
                      </div>
                      <div>
                        <div class="text text-center text-h2 text-print">
                          RELATÓRIO DA USINA <br> UNIDADE FOTOVOLTAICA MODELO
                        </div>
                      </div>
                      <div>
                        <div class="text-h2 text-right text-print capitalize_text">
                          {{formatDateFront(resultadoFatura.fatura.ucf_fim_ciclo, 'MMM/YY')}}
                        </div>
                        <div class="text-h3 text-right text-print">
                          {{formatDateFront(resultadoFatura.fatura.ucf_inicio_ciclo)}} a {{formatDateFront(resultadoFatura.fatura.ucf_fim_ciclo)}}
                        </div>
                      </div>
                    </v-row>
                  </div>
                  <div class="conteudo">
                    <!-- $root.Formatter.floatToMoney(item.ucf_valor_faturado) -->
                    <div class="text text-h2 text-print">
                      Olá <b v-if="resultadoFatura && resultadoFatura.fatura && resultadoFatura.fatura.unidade.cliente">{{resultadoFatura.fatura.unidade.cliente.cli_nome}},</b> como vai?
                      <br><br>
                      Neste mês você deveria pagar <b>R$ {{resultadoFatura.economia.valor_sem_empresa}}</b>, más como você investiu em um sistema fotovoltaico conosco, você pagará apenas <b>R$ {{resultadoFatura.economia.valor_com_empresa}}</b>.
                      <br>
                      Juntos fizemos essa grande economia, não é?
                      <br>
                      Além disso, a sua Usina produziu <b>{{resultadoFatura.producao.media}}%</b> do valor esperado!
                      <br>
                      Também analisamos sua Conta de Energia e ela está coerente com a <b class="text-blue">resolução normativa vigente</b>.
                      <br>
                      Ainda, os valores de medição informados na sua Conta de Energia estão confiáveis.
                      <br>
                      E não para por aí, tem mais informações importantes da sua usina para você analisar conosco!
                    </div>
                  </div>
                  <div>
                    <div class="text-h2 text-print">
                      <b>
                        Detalhamento da economia
                      </b>
                    </div>
                    <v-row class="mt-2">
                      <v-col cols="6">
                        <div class="text text-h2 text-print mb-2">
                          Sem a <b>Nossa Empresa</b> você pagaria R$ <b>{{resultadoFatura.economia.valor_sem_empresa}}</b>:
                        </div>
                        <div class="text text-h2 text-print mb-4">
                          <v-icon class="mr-2 icon_color">
                            check_box_outline_blank
                          </v-icon>
                          <!-- Energia Consumida Total X Tarifa = {{resultadoFatura.fatura.ucf_consumida}} kWh X {{$root.Formatter.floatToMoney(resultadoFatura.fatura.ucf_valor_tarifa)}} = R$ {{resultadoFatura.economia.valor_consumo}} -->
                          Consumo KWh em reais R$ <b>{{resultadoFatura.economia.valor_consumo}}</b>
                        </div>
                        <div class="text text-h2 text-print">
                          <v-icon class="mr-2 icon_color">
                            check_box_outline_blank
                          </v-icon>
                          Contribuição de iluminação pública + Demanda em reais = R$ <b>{{resultadoFatura.economia.valor_encargos}}</b>
                        </div>
                      </v-col>
                      <v-col cols="6" class="border_dotted" :class="$vuetify.theme.dark ? 'border_white' : 'border_black'">
                        <div class="text text-h2 text-print mb-2">
                          Com a <b>Nossa Empresa</b> você pagou R$ <b>{{resultadoFatura.economia.valor_com_empresa}}</b>:
                        </div>
                        <!-- <div class="text text-h2 text-print mb-4">
                          <v-icon class="mr-2 icon_color">
                            check_box_outline_blank
                          </v-icon>
                          Energia Faturada X Tarifa = {{resultadoFatura.fatura.ucf_faturada}} kWh X {{$root.Formatter.floatToMoney(resultadoFatura.fatura.ucf_valor_tarifa)}} = R$ {{resultadoFatura.economia.valor_faturado}}
                        </div>
                        <div class="text text-h2 text-print">
                          <v-icon class="mr-2 icon_color">
                            check_box_outline_blank
                          </v-icon>
                          Encargos/Cobranças e Adicionais de Bandeira Tarifária = R$ {{resultadoFatura.economia.valor_encargos}}
                        </div> -->
                        <div class="text text-h2 text-print">
                          <v-icon class="mr-2 icon_color">
                            check_box_outline_blank
                          </v-icon>
                          Valor da Fatura em reais R$ <b>{{resultadoFatura.economia.valor_com_empresa}}</b>
                        </div>
                      </v-col>
                    </v-row>
                    <div class="text text-h2 text-print mb-2 mt-4">
                      A sua economia nesse período foi R$ <b>{{resultadoFatura.economia.periodo}}</b>.
                      <br>
                      A economia atual é de R$ <b>{{resultadoFatura.economia.total ? resultadoFatura.economia.total : '0,00'}}</b> desde o início da operação da usina.
                      <br><br>
                      Veja a evolução da sua economia com a <b>Nossa Empresa</b> nos últimos 13 meses:
                    </div>
                    <div class="mt-8 text-center" v-if="barChartDataTwo">
                      <div class="grafico_print print_novo">
                        <bar-chart :options="barChartOptionsTwo" :height="100" :data="barChartDataTwo"></bar-chart>
                      </div>
                      <div class="grafico">
                        <bar-chart :options="barChartOptionsTwo" :height="80" :data="barChartDataTwo"></bar-chart>
                      </div>
                      <div class="mt-4">
                        <v-row no-gutters justify="center">
                          <div class="mr-3">
                            <div class="cor bg-yellow-orange text-gray"></div><span class="legenda text-print">Economia</span>
                          </div>
                          <div class="mr-3">
                            <div class="cor bg-primary text-primary"></div> <span class="legenda text-print">Com Nossa Empresa</span>
                          </div>
                          <div>
                            <div class="cor bg-gray text"></div> <span class="legenda text-print">Sem Nossa Empresa</span>
                          </div>
                        </v-row>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-else class="text-h3 text-center mt-2">
            Selecione o período, cliente e fatura.
          </div>
        </v-col>
      </v-row>
    </div>
  </v-container>
</template>

<script>
import Api from '@API'
import BarChart from '@components/graficos/BarChart.vue'
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker'
import moment from 'moment'
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css'
export default {
  components: {
    BarChart,
    VueCtkDateTimePicker
  },
  data () {
    return {
      loading: true,
      user: null,
      nivelUsuarioApelido: '',
      barChartOptions: {
        legend: { display: false },
        responsive: true,
        scales: {
          yAxes: [{
            ticks: {
              callback: function (value, index, values) {
                return value + 'kWh'
              }
            },
            stacked: true
          }]
        },
        tooltips: {
          callbacks: {
            label: function (tooltipItem, data) {
              const label = []
              const dataset = data.datasets[tooltipItem.datasetIndex]

              label.push(`${dataset.label}: ${tooltipItem.value}`)

              if ([2, 3].includes(tooltipItem.datasetIndex)) {
                const value = Number(data.datasets[2].data[tooltipItem.index]) + Number(data.datasets[3].data[tooltipItem.index])

                label.push(`Consumo cliente (kWh): ${value}`)
              }

              return label
            }
          }
        }
      },
      barChartOptionsTwo: {
        legend: { display: false },
        responsive: true,
        scales: {
          yAxes: [{
            ticks: {
              callback: function (value, index, values) {
                return value + 'kWh'
              }
            },
            stacked: true
          }]
        }
      },
      barChartData: {},
      barChartDataTwo: {},
      de: moment().startOf('month').format('YYYY-MM-DD'),
      ate: moment(new Date()).format('YYYY-MM-DD'),
      data_entrada: {
        start: moment().startOf('month').format('YYYY-MM-DD'),
        end: moment(new Date()).format('YYYY-MM-DD')
      },
      labels: [
        { key: 'thisDay', label: 'Hoje', value: 'day' },
        { key: 'last30Days', label: 'Últimos 30 dias', value: 30 },
        { key: 'thisMonth', label: 'Este mês', value: 'month' },
        { key: 'lastMonth', label: 'Mês passado', value: '-month' },
        { key: 'thisYear', label: 'Este ano', value: 'year' },
        { key: 'lastYear', label: 'Último ano', value: '-year' }
      ],
      cliente: '',
      clientes: [],
      loadingClientes: false,
      loadingSearch: false,
      relatorio: 3,
      relatorios: [
        {
          text: 'Relatório de produtividade',
          value: 1
        },
        {
          text: 'Relatório financeiro',
          value: 2
        },
        {
          text: 'Todos os modelos',
          value: 3
        }
      ],
      fatura: '',
      faturas: [],
      resultadoFiltro: false,
      loadingFaturas: false,
      resultadoFatura: [],
      arvores: 0,
      tco2: 0,
      logo: null,
      integrador: null,
      integradores: [],
      loadingIntegradores: false
    }
  },
  methods: {
    callPrint () {
      window.print()
    },
    loadFunctions () {
      this.getIntegradores()
      this.getClientes()
      this.loading = false
    },
    loadContent () {
      let filters = this.$route.query
      if (filters.modelo) this.relatorio = Number(filters.modelo)
      this.loadFunctions()
    },
    async getIntegradores () {
      this.loadingIntegradores = true
      await Api.get('integradores')
        .then(res => {
          var arrayInt = []
          res.data.map(int => {
            arrayInt.push({
              'text': int.int_nome,
              'value': int.uuid_int_id
            })
          })

          this.integradores = arrayInt
          this.loadingIntegradores = false
        })
        .catch(err => {
          this.loadingIntegradores = false
          this.$root.SnackControl.open(this, {
            text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao buscar os integradores!',
            color: 'error'
          })
          console.log(err)
        })
    },
    changeDates (dates) {
      this.de = dates.start
      this.ate = dates.end
    },
    formatDateFront (date, format = 'L') {
      return moment(date).format(format)
    },
    retornoData () {
      if (this.data_entrada.start !== this.de || this.data_entrada.end !== this.ate) {
        if (this.data_entrada.end !== null) {
          this.de = this.data_entrada.start
          this.ate = this.data_entrada.end
          this.selecionaFatura()
        }
      }
    },
    async applyFilter () {
      this.resultadoFiltro = false
      this.loadingSearch = true

      if (!this.fatura) {
        this.loadingSearch = false
        this.resultadoFiltro = false
        this.$root.SnackControl.open(this, {
          text: 'Verifique se todos os filtros foram preenchidos corretamente',
          color: 'warning'
        })
        return false
      }

      await Api.get('relatorios/acompanhamento-financeiro?fatura=' + this.fatura)
        .then(res => {
          console.log(res.data, 'fatura')
          this.resultadoFatura = res.data
          this.loadingSearch = false
          this.resultadoFiltro = true
          if (res.data.planeta && res.data.planeta.equivalencias) {
            res.data.planeta.equivalencias.map((item) => {
              if (item.name === 'Arvores Ano') {
                this.arvores = item.value
              }
              if (item.name === 'TCO2') {
                this.tco2 = item.value.toFixed(2).replace('.', ',')
              }
            })
          }
          if (res.data.producao.grafico) {
            this.barChartData = {
              labels: res.data.producao.grafico.labels,
              datasets: [
                {
                  label: 'Produção (kWh)',
                  backgroundColor: '#8A8A8A',
                  data: res.data.producao.grafico.data.producao,
                  stack: 'Stack 0'
                },
                {
                  label: 'Produção esperada (kWh)',
                  backgroundColor: '#EC6521',
                  data: res.data.producao.grafico.data.producao_estimada,
                  stack: 'Stack 1'
                },
                {
                  label: 'Consumo Instantâneo (kWh)',
                  backgroundColor: '#f6b205',
                  data: res.data.producao.grafico.data.consumo_instantaneo,
                  stack: 'Stack 2'
                },
                {
                  label: 'Energia Consumida (kWh)',
                  backgroundColor: '#4393B6',
                  data: res.data.producao.grafico.data.energia_consumida,
                  stack: 'Stack 2'
                }
              ]
            }
          }

          if (res.data.economia.grafico) {
            this.barChartDataTwo = {
              labels: res.data.economia.grafico.labels,
              datasets: [
                {
                  label: 'Economia',
                  backgroundColor: '#f6b205',
                  data: res.data.economia.grafico.data.economia,
                  stack: 'Stack 0'
                },
                {
                  label: 'Com Nossa Empresa',
                  backgroundColor: '#EC6521',
                  data: res.data.economia.grafico.data.com_empresa,
                  stack: 'Stack 1'
                },
                {
                  label: 'Sem Nossa Empresa',
                  backgroundColor: '#8A8A8A',
                  data: res.data.economia.grafico.data.sem_empresa,
                  stack: 'Stack 2'
                }
              ]
            }
          }
        })
        .catch(err => {
          this.loadingSearch = false
          this.resultadoFiltro = false
          this.$root.SnackControl.open(this, {
            text: err.response.data.message ? err.response.data.message : 'Ops, ocorreu um erro ao buscar os dados desta fatura!',
            color: 'error'
          })
        })
    },
    async getClientes () {
      this.loadingClientes = true
      let endpoint = 'clientes'

      if (this.integrador) {
        endpoint = `clientes/integrador/${this.integrador}`
      }

      await Api.get(endpoint)
        .then(res => {
          var arrayCli = []
          res.data.map(cli => {
            arrayCli.push({
              'text': cli.cli_nome,
              'value': cli.uuid_cli_id
            })
          })
          this.cliente = null
          this.faturas = []
          this.clientes = arrayCli
          this.loadingClientes = false
        })
        .catch(err => {
          this.loadingClientes = false
          this.$root.SnackControl.open(this, {
            text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao buscar os clientes!',
            color: 'error'
          })
          console.log(err)
        })
    },
    async selecionaFatura () {
      if (this.cliente) {
        this.loadingFaturas = true
        await Api.get('clientes/' + this.cliente + '/faturas?de=' + this.de + '&ate=' + this.ate)
          .then(res => {
            var arrayFat = []
            res.data.map(fa => {
              arrayFat.push({
                'text': fa.unidade.uco_nome + ' - ' + moment(fa.ucf_inicio_ciclo).format('DD/MM/YYYY') + ' - ' + moment(fa.ucf_fim_ciclo).format('DD/MM/YYYY'),
                'value': fa.uuid_ucf_id
              })
            })
            this.faturas = arrayFat
            this.loadingFaturas = false
          })
          .catch(err => {
            this.loadingFaturas = false
            this.$root.SnackControl.open(this, {
              text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao buscar as faturas!',
              color: 'error'
            })
            console.log(err)
          })
      } else {
        this.faturas = []
        this.fatura = ''
      }
    },
    calculaConsumoInstantaneo (resultadoFatura) {
      console.log({resultadoFatura})
      if (resultadoFatura) {
        const result = Number(resultadoFatura.producao.geracao) - Number(resultadoFatura.fatura.ucf_energia_injetada)

        if (result >= 0) {
          return result
        }

        return 0
      }

      return 0
    },
    updateData () {
      if (JSON.parse(localStorage.getItem('user')) !== null && !this.user) {
        this.user = JSON.parse(localStorage.getItem('user'))
        if (this.user.fk_gru_id_grupo) {
          this.nivelUsuarioApelido = 'M'
        }
        if (this.user.fk_dis_id_distribuidor) {
          this.nivelUsuarioApelido = 'D'
        }
        if (this.user.fk_int_id_integrador) {
          this.nivelUsuarioApelido = 'I'
        }
      }
    }
  },
  updated () {
    this.updateData()
  },
  created () {
    this.updateData()
    this.loadContent()
  }
}
</script>

<style lang="scss" scoped>
@import "@scss/_variables.scss";
@import "@scss/_ui.scss";
.area_img_fundo {
  position: relative;
  img {
    border-radius: 60px;
  }
}
.economizou {
  color: $primary;
  font-size: 36px;
  font-weight: bold;
  left: 40px;
  position: absolute;
  top: 70px;
}
.inicio {
  bottom: 40px;
  color: $primary;
  font-size: 36px;
  font-weight: bold;
  left: 40px;
  position: absolute;
}
.left_card {
  margin-top: 8px;
  padding-left: 20px;
  width: 120px;
  img {
    max-width: 100px;
  }
}
.right_card {
  padding-left: 10px;
  width: calc(100% - 120px);
}
.mw_vcard {
  max-width: 450px;
}
.resultados {
  position: relative;
  img {
    border-radius: 30px;
  }
}
.potencia_detalhe {
  margin-bottom: 15px;
}
.parabens {
  margin-top: 30px;
}
.margin_contribuicao {
  margin-top: 15px;
}
.text_number {
  color: #000;
  font-size: 14px;
  font-weight: bold;
  position: absolute;
}
.consumo_registrado {
  left: 200px;
  top: 50px;
}
.unidade_geradora {
  left: 30px;
  top: 158px;
}
.consumo_instantaneo {
  bottom: 85px;
  left: 65px;
}
.energia_injetada {
  bottom: 105px;
  right: 65px;
}
.geracao {
  left: 205px;
  bottom: 15px;
}
.vcard_border {
  border-radius: 60px;
  padding-right: 20px;
}
.vcard_border_parabens {
  border-radius: 80px;
}
.cor {
  border-radius: 100%;
  float: left;
  height: 30px;
  margin-right: 8px;
  width: 30px;
  -webkit-print-color-adjust: exact;
}
.legenda {
  line-height: 30px;
}
.grafico {
  display: block;
}
.grafico_print {
  position: absolute;
  top: -1500px;
  width: 450px;
}
.print_container {
  margin: 0 auto;
  width: 1232px!important;
}
.segunda_pagina {
  margin-top: 50px;
}
.topo_segunda_pagina {
  margin-bottom: 20px;
}
.border_dotted {
  position: relative;
  &:before {
    border-left: 2px dashed #000;
    content: '';
    height: 100%;
    left: -10px;
    position: absolute;
    top: 0;
  }
}
.print_novo {
  width: 1000px!important;
}
>>> .search_btn  {
  .v-btn {
    min-width: inherit!important;
    padding-top: 8px !important;
    padding-bottom: 8px !important;
    margin-bottom: 3px;
  }
}
.mw_maior {
  max-width: 330px;
}
.capitalize_text {
  &:first-letter {
    text-transform: uppercase;
  }
}
.border_white {
  &:before {
    border-color: white;
  }
}
.border_black {
  &:before {
    border-color: black;
  }
}
@media (max-width: 1903px){
  .consumo_registrado {
    left: 265px;
    top: 60px;
  }
  .unidade_geradora {
    left: 45px;
    top: 205px;
  }
  .consumo_instantaneo {
    left: 90px;
  }
  .energia_injetada {
    right: 85px;
  }
  .geracao {
    left: 265px;
  }
}
@media (max-width: 1263px){
  .consumo_registrado {
    left: 245px;
    top: 65px;
  }
  .unidade_geradora {
    left: 40px;
    top: 195px;
  }
  .consumo_instantaneo {
    bottom: 95px;
    left: 85px;
  }
  .energia_injetada {
    bottom: 125px;
    right: 85px;
  }
  .geracao {
    left: 250px;
  }
}
@media (max-width: 1280px){
  .print_container {
    width: 1000px!important;
  }
}
@media (max-width: 1280px){
  .consumo_registrado {
    left: 210px;
    top: 50px;
  }
  .unidade_geradora {
    left: 30px;
    top: 165px;
  }
  .consumo_instantaneo {
    bottom: 85px;
    left: 60px;
  }
  .energia_injetada {
    bottom: 90px;
    right: 60px;
  }
  .geracao {
    left: 195px;
  }
}
@media (max-width: 1075px){
  .print_container {
    width: 100%!important;
  }
}
@media print {
  .print_container {
    width: 100%!important;
  }
  .hide_print {
    display: none;
  }
  .area_img_fundo {
    img {
      border-radius: 0px;
    }
  }
  .border_white {
    &:before {
      border-color: black;
    }
  }
  .print_area {
    margin-top: -70px;
    margin-left: -26px;
    max-width: 100%!important;
  }
  .col_print {
    width: 50%!important;
  }
  .economizou {
    font-size: 30px;
    left: 30px;
    top: 60px;
  }
  .inicio {
    bottom: 60px;
    font-size: 30px;
    left: 30px;
    position: absolute;
  }
  .potencia_detalhe {
    font-size: 14px;
    margin-bottom: 5px;
  }
  .parabens {
    margin-top: 20px;
  }
  .margin_contribuicao {
    margin-top: 0px;
  }
  .text-print {
    color: #000;
  }
  .valores_aproximados {
    margin-top: -10px;
  }
  .text_number {
    font-size: 12px;
  }
  .legenda {
    font-size: 12px;
  }
  .grafico_print {
    position: relative;
    top: 0;
  }
  .grafico {
    display: none;
  }
  .resultados {
    img {
      max-width: 490px;
    }
  }
  .producao_print {
    margin-bottom: 20px;
    margin-top: 15px;
  }
  .text-h1 {
    font-size: 36px!important;
  }
  .font_valor {
    font-size: 36px!important;
  }
  .segunda_pagina {
    padding-top: 50px;
    margin-top: 350px;
  }
  .conteudo {
    margin-bottom: 20px;
  }
  .icon_color {
    color: black;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/relatorios/atendimento/GeralCliente.vue